import { render, staticRenderFns } from "./Navbarcreateexercise.vue?vue&type=template&id=0008d4f4&"
import script from "./Navbarcreateexercise.vue?vue&type=script&lang=js&"
export * from "./Navbarcreateexercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports